import { DropdownItemProps } from 'semantic-ui-react/dist/commonjs/modules/Dropdown/DropdownItem'

export const NFTSortingList: any[] = [
  {
    key: 'NewestItems',
    text: 'Newest',
    value: 'NewestItems'
  },
  {
    key: 'OldestItems',
    text: 'Oldest',
    value: 'OldestItems'
  },
  {
    key: 'PriceLowToHigh',
    text: 'Price - Low to High',
    value: 'PriceLowToHigh'
  },
  {
    key: 'PriceHighToLow',
    text: 'Price - High to Low',
    value: 'PriceHighToLow'
  }
]

export const NFTPerPage: any[] = [
  {
    key: '16Items',
    text: '16',
    value: 16
  },
  {
    key: '20Items',
    text: '20',
    value: 20
  },
  {
    key: '36Items',
    text: '36',
    value: 36
  },
  {
    key: '48Items',
    text: '48',
    value: 48
  }
]
